import React, { FC } from 'react';

import { useAppSelector } from 'store';
import { profileSelector } from 'store/auth/auth.selectors';
import { IUser } from 'types';
import { ProfileView } from './components/ProfileView/ProfileView';
import {ReactComponent as ProfileIcon} from 'icons/profile_icon.svg'
import styles from './components/ProfileView/ProfileView.module.scss';

const ProfilePage: FC = () => {
  const profile = useAppSelector(profileSelector);

  return (
    <div>
      <div className={styles.header}>
        <ProfileIcon />
      <p style={{marginLeft: '10px', fontWeight: 'bold',fontSize: '28px'}}>Персональные данные</p>
      </div>
      
    <ProfileView data={profile as IUser} />
    </div>
  );
};

export default ProfilePage;
